import { apiStatus, odrActionType } from '../../../actionTypes';

const initialState = {
  apiState: apiStatus.NONE,
  errorMessage: '',
  data: '',
};

const updateTicket = (state = initialState, action) => {
  switch (action.type) {
    case odrActionType.UPDATE_TICKET_REQUEST:
      return {
        ...state,
        apiState: apiStatus.INITIATED,
      };
    case odrActionType.UPDATE_TICKET_SUCCESS:
      const data = action.payload || '';
      return {
        ...state,
        data,
        apiState: apiStatus.SUCCESS,
      };
    case odrActionType.UPDATE_TICKET_FAILURE:
      const { errorMessage } = action.payload;
      return {
        ...state,
        apiState: apiStatus.ERROR,
        errorMessage,
      };
    default:
      return state;
  }
};

export default updateTicket;



// WEBPACK FOOTER //
// ./reducer/odr/updateTicket/index.js